import {
  APPOINTMENT_STATUS,
  AppointmentViewDetail,
  PatientProviderDashboard,
  VIEW_DETAIL_TYPE,
} from '~/store/services/providerDashboard';
import { AppointmentStatusCounts, STATUS_COLORS, STATUS_KEYS, STATUS_LABELS } from '../constants';
import type { StatusKey } from '../constants';

export const getBorderRadius = (isFirst: boolean, isLast: boolean): string => {
  if (isFirst && isLast) return 'full';
  if (isFirst) return '7px 0px 0px 7px';
  if (isLast) return '0px 7px 7px 0px';
  return '0px';
};

export const getVisibleStatusKeys = (
  summary: Record<StatusKey, number>,
): StatusKey[] => {
  return STATUS_KEYS.filter((k) => summary[k] > 0);
};

export function deriveStatusCounts(
  patients: PatientProviderDashboard[],
): AppointmentStatusCounts {
  const counts: AppointmentStatusCounts = {
    total: 0,
    fulfilled: 0,
    cancelledByPatient: 0,
    noShow: 0,
    upcoming: 0,
  };

  for (const patient of patients) {
    if (patient.viewDetail?.type !== VIEW_DETAIL_TYPE.APPOINTMENT) continue;
    const appt = patient.viewDetail as AppointmentViewDetail;
    counts.total++;
    switch (appt.status) {
      case APPOINTMENT_STATUS.FULFILLED:
        counts.fulfilled++;
        break;
      case APPOINTMENT_STATUS.CANCELLED_BY_PATIENT:
        counts.cancelledByPatient++;
        break;
      case APPOINTMENT_STATUS.NO_SHOW:
        counts.noShow++;
        break;
      case APPOINTMENT_STATUS.UPCOMING:
        counts.upcoming++;
        break;
    }
  }
  return counts;
}

export { STATUS_COLORS, STATUS_KEYS, STATUS_LABELS };
export type { StatusKey };
